export default "__VITE_ASSET__BINK_6gJ__"